import styled from '@emotion/styled';
import { MultiCombobox as CyMultiCombobox, MultiComboboxProps } from '@applyboard/crystal-ui';

// Extended props to include scrollable which exists in Crystal UI but not in types
interface ExtendedMultiComboboxProps extends MultiComboboxProps {
  scrollable?: boolean;
}

export function MultiCombobox(props: MultiComboboxProps) {
  const extendedProps: ExtendedMultiComboboxProps = { ...props, scrollable: true };
  return (
    <Styles>
      <CyMultiCombobox {...extendedProps} />
    </Styles>
  );
}
MultiCombobox.Option = CyMultiCombobox.Option;

const Styles = styled.div({
  '& button': {
    backgroundColor: '#f3f3f3',
    border: '0',
  },
  '& [role="listbox"], & [role="menu"]': {
    maxHeight: '350px',
    overflowY: 'auto',
  },
  '& div[data-testid*="dropdown"], & div[class*="dropdown"], & div[class*="menu"]': {
    maxHeight: '350px',
    overflowY: 'auto',
  },
});
